
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUsuarioActual } from "../../components/services/PersonaService";


import jwtDecode from "jwt-decode";
import { SpinnerCircle } from "../atoms/spinner/Spinner";
import Footer from "../molecules/footer/Footer";
import Header from "../molecules/header/Header";


const ClaveBienvenida = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);

  const query = window.location.href;
  const queryString = decodeURIComponent(query.replace(/\+/g, ' '));
  //const token = JSON.parse(queryString.split("?token=")[1]);

  
  const token = queryString.split("?token=")[1];
  



  const tokenJwt = jwtDecode(token);
  

  
  
  

  const json = {
    "nombreCompleto": tokenJwt?.NOMBRE_COMPLETO,
    "nombre": user?.nombre,
    "apellido1": user?.apellido1,
    "apellido2": user?.apellido2,
    "niep": user?.niep,
    "letniep": user?.letniep,
    "roles": user?.roles
  };

  /*const json = {
    "token":token,
    "type":"Bearer",
    "xpersona":28186,
    "username":"xJAMBENITEZ",
    "nombre":user?.nombre,
    "apellido1":user?.apellido1,
    "apellido2":user?.apellido2,
    "niep":user?.niep,
    "letniep":user?.letniep,
    "roles":["ROLE_EMPLEADO_PUBLICO","ROLE_ADMIN"],
    "accessToken":token,
    "tokenType":"Bearer"
    };*/

  
  

  
  

  const credB =localStorage.getItem('credbloqueado')
  useEffect(() => {
    localStorage.clear();
    localStorage.setItem("credbloqueado",JSON.stringify(credB))
    //realizar peticion GET a http://localhost:8082/areadepersonalapi/auth/user para obtener datos del usuario  

    getUsuarioActual().then((data) => {
      if (!data.toString().startsWith("Error:")) {
        setUser(data);
        
        
        const json2 = {
          "nombreCompleto": tokenJwt?.NOMBRE_COMPLETO,
          "nombre": data?.nombre,
          "apellido1": data?.apellido1,
          "apellido2": data?.apellido2,
          "niep": data?.niep,
          "letniep": data?.letniep,
          "roles": data?.roles
        };

        localStorage.setItem("user", JSON.stringify(json2));
        localStorage.setItem("showModalHome",true)
        
        
        navigate("/home");

      }
    });

    localStorage.setItem("user", JSON.stringify(json));
    // eslint-disable-next-line
  },[credB,tokenJwt,json,token]);

  return (
    <>
      {/* Si se añaden distintos dominios se podria obtener a través para idnicar donde se desea mostrar y donde no con : 
      window.location.hostname; */}.
      {
        loginPersonal()
      }
    </>
  );
};
export default ClaveBienvenida;


function loginPersonal() {
  return (
    <div className="me-auto ms-auto d-flex flex-column vh-100">
      <Header/>
      <div className="">
        <SpinnerCircle/>
      </div>
      <Footer/>
    </div>

  );
}
